import { addHours } from "date-fns";

/**
 * Shared low-level primitive: apply a tz offset (hours from UTC) then format the
 * instant in UTC via Intl, so the result is independent of the browser timezone.
 * All UTC-locale formatters build on this to avoid duplicating the
 * addHours + toLocaleString("en-US", { timeZone: "UTC", ... }) idiom.
 *
 * NOTE: timeZone:"UTC" is injected FIRST so callers can override nothing by
 * accident; spread your own options after — they win (…format last).
 */
export const formatInUTC = (
  date: Date,
  options: Intl.DateTimeFormatOptions,
  tz = 0
): string =>
  addHours(date, tz).toLocaleString("en-US", { timeZone: "UTC", ...options });
